module.exports = __webpack_public_path__ + "static/slide-components-eefa38db8931d1cadb95b6016f3523f7.svg";